import { lazy, Suspense } from "react";

const Slider = lazy(() => import("react-slick"));
import classNames from "classnames";

import LazyImage from "../LazyImage";
import ReportedPostBody from "../ReportedPostBody";

import styles from "./index.module.scss";

const ViewPostModalReported = ({ content, postId }) => (
  <div className="overflow-hidden w-100 rounded">
    <div className={classNames(styles.description, "my-auto w-100")}>
      <Suspense fallback="Loading...">
        <Slider>
          {content?.map(({ id, link }) => (
            <div key={id} className="m-auto">
              <LazyImage
                src={link}
                imageClassName="mh-100 "
                wrapperClassName={styles.image}
              />
            </div>
          ))}
        </Slider>
      </Suspense>
    </div>
    <ReportedPostBody postId={postId} hideIcon modalView />
  </div>
);

export default ViewPostModalReported;
